export default {
  0: '指定なし',
  1: 'テーブル',
  2: '座敷',
  3: 'カウンター',
  4: '掘りごたつ',
  5: 'テラス',
  6: 'ソファー',
  99: 'その他',
}
